<ion-card class="completeCard">
  <ion-card-header>
    <ion-card-title class="ion-text-center">{{status?.application?.name}}</ion-card-title>
    <ion-card-subtitle class="ion-text-center">{{status?.application?.specialty}}</ion-card-subtitle>
    <ion-card-subtitle class="ion-text-center">Completed: {{status?.application?.startdate | date: 'longDate' : 'UTC' }}
      -
      {{status?.application?.enddate | date: 'longDate' : 'UTC' }}</ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <ion-list>
      <ion-item>
        <ion-label class="ion-text-wrap">
          <ion-text>
            <h2><b>{{content?.content?.applicationcompleted?.card1title}}</b></h2>
          </ion-text>
          <ion-text>
            <p>{{content?.content?.applicationcompleted?.card1instructions}}</p>
          </ion-text>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label class="ion-text-wrap">
          <ion-text>
            <h2><b>{{content?.content?.applicationcompleted?.card2title}}</b></h2>
          </ion-text>
          <ion-text>
            <p>{{content?.content?.applicationcompleted?.card2instructions}}</p>
          </ion-text>
        </ion-label>
      </ion-item>
      <ion-item detail button (click)="downloadCertificate()">
        <ion-label>
          <ion-text color="primary">
            {{content?.content?.applicationcompleted?.card2button}}
          </ion-text>
        </ion-label>
        <ion-icon name="cloud-download" slot="start" color="primary"></ion-icon>
      </ion-item>
    </ion-list>
  </ion-card-content>
  <ion-card-content class="ion-text-center">
    <ion-col size="12" size-xs="2" size-sm="2" size-md="1" size-lg="1" size-xl="1">
      <ion-button (click)="toInstagram()" fill="clear">
        <ion-icon slot="icon-only" size="large" name="logo-instagram"></ion-icon>
      </ion-button>
    </ion-col>
    <ion-col size="12" size-xs="2" size-sm="2" size-md="1" size-lg="1" size-xl="1">
      <ion-button (click)="toFacebook()" fill="clear">
        <ion-icon slot="icon-only" size="large" name="logo-facebook"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-card-content>
</ion-card>